import {Alert} from '@freckle/educator-materials/ts/components/alert'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'

export const TooManySchoolsAlert = () => {
  const {t} = useSafeTranslation()

  return <Alert type="warning">{t('MANAGE_TEACHERS_TAB_TOO_MANY_SCHOOLS_ALERT')}</Alert>
}
